<template>
  <div class="abwrapper">
    <b-input v-model="txt"></b-input>
    <b-button @click="reg()">변환</b-button>
    <div>
      {{ rep1 }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      txt: "",
      rep1: "",
    };
  },
  methods: {
    reg() {
      // var myRe = new RegExp("(<[^>]*>|s|_|{d*})", "g");

      this.rep1 = this.txt.replace(/(<[^>]*>|\s|_|{\d*}|\(|\)|\.|→|,)/gi, "");
    },
  },
};
</script>


<style lang="scss" scoped>
.abwrapper {
  padding: 10px;
}
</style>